import axios, { AxiosResponse } from "axios";
import { TokenService } from "@/services";
import { FormError } from "../dto/errors/FormError.ts";
import { RequestError } from "@/services/BaseService.ts";
import { apiRequester, csrfRequester } from "@/libs/core/axios.ts";

export default abstract class BaseRepository {

  setHeader() {
    apiRequester!.defaults.headers.common["Authorization"] =
      `Bearer ${TokenService.getToken()}`;
  }

  removeHeader() {
    apiRequester!.defaults.headers.common = {};
  }

  get(resource: string) {
    return apiRequester!.get(resource).catch((err: any) => {
      return this.handleErrorResponse(err.response);
    });
  }

  async post(resource: string, data: any) {
    await this.requestCsrfCookie();
    return apiRequester!.post(resource, data).catch((err: any) => {
      return this.handleErrorResponse(err.response);
    });
  }

  put(resource: string, data: any) {
    return apiRequester!.put(resource, data).catch((err: any) => {
      return this.handleErrorResponse(err.response);
    });
  }

  delete(resource: string) {
    return apiRequester!.delete(resource).catch((err: any) => {
      return this.handleErrorResponse(err.response);
    });
  }

  async requestCsrfCookie(): Promise<void> {
    return await csrfRequester!.get("/sanctum/csrf-cookie");
  }

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data: any) {
    return axios(data);
  }

  handleErrorResponse(response: AxiosResponse) {
    if (!response) {
      throw new RequestError("500", "Connection error.");
    }

    if (response.status === 422) {
      throw new FormError(response.data.errors);
    } else if (response.status === 400) {
      throw new RequestError(response.status.toString(), response.data.error);
    } else {
      console.log("handleErrorResponse (%s):", response.status, response.data);
      throw new RequestError(response.status.toString(), response.data.message);
    }
  }
}
